import TheNews from './TheNews.jsx';

export {
  TheNews
}


// WEBPACK FOOTER //
// ./components/users/sub-view/the-news/index.js